import { render, staticRenderFns } from "./modal_upload.vue?vue&type=template&id=0c401d08&scoped=true"
import script from "./modal_upload.vue?vue&type=script&lang=js"
export * from "./modal_upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c401d08",
  null
  
)

export default component.exports